export function PrimaryLayoutFooter() {
  return (
    <footer className="border-t border-[#66B28A] bg-[#C8E7FF]">
      <div className="mx-auto grid w-[90%] max-w-[1440px] grid-cols-1 gap-8 py-8 text-[14px] text-[#1f2a2e] md:grid-cols-3">
        <div>
          <div className="mb-3 font-semibold">Контакты</div>
          <a href="tel:+78005559983" className="block hover:underline">
            8 (800) 555 99 83
          </a>
          <a href="mailto:office@liliani.ru" className="block hover:underline">
            office@liliani.ru
          </a>
          <div className="mt-2 text-[#44525a]">
            346884, Ростовская обл., г. Батайск, Восточное шоссе, 14, пом. 401
          </div>
        </div>

        <div>
          <div className="mb-3 font-semibold">Компания</div>
          <div>ООО «ЛИЛИАНИ»</div>
          <div>ИНН 6162031892</div>
          <div>ОГРН 1026103053426</div>
          <a
            href="https://liliani.ru"
            target="_blank"
            rel="noreferrer"
            className="mt-2 inline-block text-[#007E3C] hover:underline">
            liliani.ru
          </a>
        </div>

        <div>
          <div className="mb-3 font-semibold">Документы</div>
          <a
            href="https://liliani.ru/policy/"
            target="_blank"
            rel="noreferrer"
            className="block text-[#007E3C] hover:underline">
            Политика обработки персональных данных
          </a>
          <a
            href="https://liliani.ru/rules/"
            target="_blank"
            rel="noreferrer"
            className="mt-2 block text-[#007E3C] hover:underline">
            Правила пользования сайтом (оферта)
          </a>
        </div>
      </div>

      <div className="border-t border-[#a9d4f2] py-3 text-center text-[13px] text-[#44525a]">
        © 2026 ООО «ЛИЛИАНИ». Все права защищены.
      </div>
    </footer>
  );
}
